import auth from './modules/auth.json';
import components from './modules/components.json';
import qualityAssistant from './modules/qualityAssistant.json';
import jiraIntegration from './modules/jiraIntegration.json';
import testCycles from './modules/testCycles.json';
import missionControl from './modules/missionControl.json';
import personaGuide from './modules/personaGuide.json';
import safeChangeFlow from './modules/safeChangeFlow.json';
import translationLegacy from './translation.json';
// Import d'autres modules à venir...
// Force reload timestamp: 2025-10-07

export default {
  // Import des anciennes traductions comme base
  ...translationLegacy,

  // Clés de base (écrasent les anciennes si nécessaire)
  app: {
    title: "Nodemented",
    description: "Knowledge graph management platform",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    warning: "Warning",
    info: "Information"
  },

  // Modules (écrasent les anciennes si nécessaire)
  ...auth,
  ...components,
  qualityAssistant,
  ...jiraIntegration,
  testCycles,
  ...missionControl,
  ...personaGuide,
  ...safeChangeFlow,

  // Other sections to migrate progressively from translation.json
  navigation: {
    dashboard: "Return to Dashboard",
    nodes: "Nodes",
    relationships: "Create Relationships",
    search: "Search",
    profile: "Profile",
    settings: "Settings",
    help: "Help",
    about: "About",
    // New keys for refactored navigation
    sections: "Laboratory Sections",
    sectionsDesc: "Easily create your detailed documentation, its relationships, and associated tests! Analyze your test coverage and generate specifications with AI.",
    primarySections: "Primary Sections",
    advancedSections: "Advanced Sections",
    selectedNode: "Selected node",
    createNode: "Create / Modify Node",
    createNodeDesc: "Create or modify a node",
    nodesList: "Nodes List",
    nodesListDesc: "Browse all your nodes",
    relations: "Nodes Relations",
    relationsDesc: "Manage relationships between nodes",
    tests: "Tests",
    testsDesc: "Manage, Create and View tests",
    importCode: "Code Import",
    importCodeDesc: "Create nodes from code",
    quickCreate: "Quick Create",
    quickCreateDesc: "Easily create nodes and relationships in natural language using AI",
    vectorSearch: "Quality Assistant and Vector search",
    vectorSearchDesc: "Analyse and Search in knowledge base",
    analysis: "Tests Coverage",
    analysisDesc: "Detailed tests coverage report",
    specifications: "IA Specifications Manager",
    specificationsDesc: "Create & Manage IA specifications",
    jiraImport: "JIRA Import",
    jiraImportDesc: "Import your JIRA tickets and automatically generate nodes with AI"
  },

  // Translations for mobile lab interface
  mobileLabView: {
    tabs: {
      nodes: "Nodes",
      create: "Create",
      relations: "Relations",
      tests: "Tests",
      graph: "Graph"
    },
    searchNodes: "Search a node...",
    nodesFound: "nodes found",
    relations: "relations",
    createRelation: "Create relation",
    testsFor: "Tests for {{nodeName}}",
    runTests: "Run tests",
    backToNodes: "Back to nodes",
    selectNodeFirst: "Select a node first to see its details",
    browseNodes: "Browse nodes",
    mobileOptimized: "Mobile optimized interface",
    swipeHint: "Swipe to navigate between sections",

    // Simplified version
    viewOnlyMode: "View-only mode",
    editOnDesktop: "To edit, use the desktop version",
    graphVisualization: "Graph visualization",
    graphDescription: "Explore your nodes and relationships interactively",
    nodesOverview: "Nodes overview",
    relationshipsOverview: "Relationships overview",
    testsOverview: "Tests overview",
    testResults: "Test results"
  },

  // Translations for mobile node creation
  mobileCreateNode: {
    title: "Create a new node",
    basicInfo: "Basic information",
    advancedInfo: "Advanced information",
    nodeName: "Node name",
    nodeNamePlaceholder: "Enter the node name...",
    nodeType: "Node type",
    selectType: "Select a type",
    description: "Description",
    descriptionPlaceholder: "Describe the feature or objective...",
    technology: "Technology",
    selectTechnology: "Select a technology",
    featureTeam: "Feature Team",
    featureTeamPlaceholder: "E.g. Frontend Team, Backend Squad...",
    featureTeamHint: "Groups nodes visually by team in the graph",
    status: "Status",
    selectStatus: "Select a status",
    metadata: "Metadata (JSON)",
    metadataPlaceholder: "{\n  \"priority\": \"high\",\n  \"category\": \"frontend\"\n}",
    jsonFormat: "Valid JSON format required",
    advancedOptions: "Advanced options",
    createNode: "Create node",
    creating: "Creating...",
    back: "Back",
    reset: "Reset",
    nameRequired: "Node name is required"
  },

  // GraphSection navigation and filters
  graphSection: {
    title: "Graph Visualization",
    description: "Explore your nodes and their relationships interactively",
    expandFilter: "Expand filter",
    collapseFilter: "Collapse filter",
    hideFilter: "Hide Filter"
  },

  // Translations for mobile graph
  mobileGraph: {
    searchNodes: "Search in graph...",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    fitView: "Fit to view",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit fullscreen",
    nodes: "nodes",
    relations: "relations",
    found: "found",
    labels: "Labels",
    physics: "Physics",
    loading: "Loading graph...",
    noData: "No data to display",
    createNodesFirst: "Create nodes to see the graph",
    graphView: "Graph view",
    interactiveMode: "Interactive mode",
    staticMode: "Static mode"
  }
};
